import { Link } from "react-router-dom";

export default function HowItWorks() {
  return (
    <section
      className="relative py-16 md:py-24 bg-cover bg-center"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&h=800&fit=crop')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex justify-center">
          {/* White content card */}
          <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 max-w-lg w-full shadow-2xl">
            <span className="text-xs sm:text-sm font-semibold text-orange-500 uppercase tracking-wider">
              OUR PROCESS
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight mt-2 mb-4 sm:mb-6 text-black">
              HOW RENTING WORKS
              <br />
              WITH RAULFEX
            </h2>
            <p className="text-gray-600 text-sm sm:text-base mb-6 sm:mb-8">
              We make renting property effortless. Here's how we guide you
              every step of the way.
            </p>

            {/* Steps */}
            <div className="space-y-5 sm:space-y-6">
              <div className="flex items-start gap-3 sm:gap-4">
                <span className="text-xl sm:text-2xl font-bold text-orange-500">01.</span>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-black mb-1">
                    Explore
                  </h3>
                  <p className="text-gray-600 text-xs sm:text-sm">
                    Browse our available properties that fit your needs.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <span className="text-xl sm:text-2xl font-bold text-orange-500">02.</span>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-black mb-1">Apply</h3>
                  <p className="text-gray-600 text-xs sm:text-sm">
                    Apply online via our simple application form.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <span className="text-xl sm:text-2xl font-bold text-orange-500">03.</span>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-black mb-1">
                    Submit
                  </h3>
                  <p className="text-gray-600 text-xs sm:text-sm">
                    Submit required documents for verification.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <span className="text-xl sm:text-2xl font-bold text-orange-500">04.</span>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-black mb-1">
                    Secure
                  </h3>
                  <p className="text-gray-600 text-xs sm:text-sm">
                    Sign your lease agreement and move in.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 sm:mt-8">
              <Link to="/properties">
                <button className="w-full sm:w-auto px-6 sm:px-8 py-3 rounded-full bg-orange-500 text-white font-semibold hover:bg-orange-600 transition-colors duration-300 shadow-lg hover:shadow-xl">
                  Start your journey
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}